export const formatPeriod = (period) => {
  if (typeof period !== "string" || period.length === 0) return "";
  return `${period.charAt(0).toUpperCase()}${period.slice(1)}`;
};